module.exports = __webpack_public_path__ + "static/media/file_view.cd49638d.svg";